import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class ScheduleIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm0 23C6 23 1 18.1 1 12S5.9 1 12 1s11 4.9 11 11c0 6-4.9 11-11 11zm.3-8.6c-.1 0-.2 0-.3-.1l-5.1-3.9c-.2-.2-.3-.5-.1-.7.2-.2.5-.2.7-.1l4.3 3.3V4.3c0-.3.2-.5.5-.5s.5.2.5.5v9.6c0 .2-.1.3-.3.4-.1.1-.1.1-.2.1z" fill="#b9c2c5"/></svg>
        )
    }
}

export default withCssClassName(ScheduleIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/schedule-icon.js